import { DetailedHTMLProps, FunctionComponent, HTMLAttributes } from "react";
import { Theme } from "..";
import TextAlignWrapper, { TextAlign } from "../TextAlignWrapper";
import styles from "./styles.module.scss";

export type Heading2Props = DetailedHTMLProps<HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement> & {
  bold?: boolean,
  textAlign?: TextAlign,
  theme?: Theme,
};

const Heading2: FunctionComponent<Heading2Props> = ({ className, children, bold, textAlign, theme, ...props }: Heading2Props) => {
  return (
    <TextAlignWrapper textAlign={textAlign ?? TextAlign.Left}>
      <h2 className={`${styles.heading2} ${bold === false ? styles.regular : ""} ${styles[theme ?? Theme.Light]} ${className ?? ""}`} {...props}>
        {children}
      </h2>
    </TextAlignWrapper>
  );
};

export default Heading2;